import { useEffect } from "react";

let locks = 0;
let savedY = 0;

function lock(classes) {
  if (locks === 0) {
    savedY = window.scrollY || 0;
    document.body.style.top = `-${savedY}px`;
  }
  locks += 1;
  classes.forEach((c) => {
    document.documentElement.classList.add(c);
    document.body.classList.add(c);
  });
}

function unlock(classes) {
  classes.forEach((c) => {
    document.documentElement.classList.remove(c);
    document.body.classList.remove(c);
  });
  locks -= 1;
  if (locks === 0) {
    document.body.style.top = "";
    window.scrollTo(0, savedY);
  }
}

// Freezes the page behind a full-screen panel and restores the scroll position when it closes.
export default function useBodyLock(...classes) {
  const key = classes.join(" ");
  useEffect(() => {
    const list = key.split(" ").filter(Boolean);
    lock(list);
    return () => unlock(list);
  }, [key]);
}
